export type ScheduleDayGroup<T> = {date:string;rows:Array<{day:T;index:number}>};

/** One visible card per Sydney day; crew-day rows remain independent inside it. */
export function groupScheduleDays<T extends {date:string}>(days:T[]):ScheduleDayGroup<T>[] {
  const groups:ScheduleDayGroup<T>[]=[];
  const byDate=new Map<string,ScheduleDayGroup<T>>();
  days.forEach((day,index)=>{
    // There can only be one new undated card: Add next day stays disabled until it has a date.
    const key=day.date||'__new_day__';
    let group=byDate.get(key);
    if(!group){group={date:day.date,rows:[]};byDate.set(key,group);groups.push(group);}
    group.rows.push({day,index});
  });
  return groups;
}

/** One job on one day has one shared work scope, even when several crews attend. Preserve every
 * saved work item when normalising older rows that happened to disagree. */
export function shareDayTasks<T extends {date:string;taskLineIds:string[]}>(days:T[]):T[] {
  const shared=new Map<string,string[]>();
  for(const day of days){
    const current=shared.get(day.date)??[];
    shared.set(day.date,[...new Set([...current,...day.taskLineIds])]);
  }
  return days.map(day=>({...day,taskLineIds:[...(shared.get(day.date)??[])]}));
}
